import { useContext } from 'react'

import { viewTypes } from '@/common/components/FilterViews/constants'
import AppContext from '@/common/context/app.context'
import useNavigateToFilterView from '@/common/hooks/useNavigateToFilterView/useNavigateToFilterView'
import { defaultViews } from '@/returns/pages/TransactionsPage/constants'
import routes from '@/Router/routes.constants'

import EarningsFromUpSells from './EarningsFromUpSells/EarningsFromUpSells'
import EarningsRetainedAsExchanges from './EarningsRetainedAsExchanges/EarningsRetainedAsExchanges'
import EarningsRetainedAsStoreCredit from './EarningsRetainedAsStoreCredit/EarningsRetainedAsStoreCredit'
import GeneralMetricsCardSkeleton from './GeneralMetricsCardSkeleton/GeneralMetricsCardSkeleton'
import TransactionsAboutToExpire from './TransactionsAboutToExpire/TransactionsAboutToExpire'
import TransactionsForReview from './TransactionsForReview/TransactionsForReview'
import TransactionsOnHold from './TransactionsOnHold/TransactionsOnHold'
import * as Styles from './styles'

const GeneralMetricsCard = ({
  metrics,
  currency,
  loading,
  isUnifiedDashboard,
  giftCardAllowed,
  storeCreditAllowed,
}) => {
  const { info, updateContext } = useContext(AppContext)
  const { handleGoView } = useNavigateToFilterView({
    viewType: viewTypes.transactions,
    defaultViews,
    updateContext,
    storeId: info?.selectedStore?.id,
    route: isUnifiedDashboard ? routes.merchantTransactionsPage : routes.transactionsPage,
  })

  const handleClickInStat = stat => {
    handleGoView(defaultViews.find(view => view.id === stat))
  }

  if (loading) return <GeneralMetricsCardSkeleton />

  return (
    <Styles.InsightsRow>
      <Styles.TransactionsStatsContainer>
        <Styles.StatContainer>
          <TransactionsAboutToExpire
            transactionsAboutToExpire={metrics?.transactions_about_to_expire}
            onClick={handleClickInStat}
          />
        </Styles.StatContainer>
        <Styles.StatContainer>
          <TransactionsForReview transactionsForReview={metrics?.transactions_for_review} onClick={handleClickInStat} />
        </Styles.StatContainer>
        <Styles.StatContainer>
          <TransactionsOnHold transactionsOnHold={metrics?.transactions_on_hold} onClick={handleClickInStat} />
        </Styles.StatContainer>
      </Styles.TransactionsStatsContainer>
      <Styles.EarningsGroup>
        <EarningsFromUpSells earningsFromUpSells={metrics?.earnings_saved_as_upsells} currency={currency} />
        <EarningsRetainedAsStoreCredit
          earningsRetainedAsStoreCredit={metrics?.earnings_saved_as_store_credit}
          earningsRetainedAsGiftCard={metrics?.earnings_saved_as_gift_card}
          giftCardAllowed={giftCardAllowed}
          storeCreditAllowed={storeCreditAllowed}
          currency={currency}
        />
        <EarningsRetainedAsExchanges
          earningsRetainedAsExchanges={metrics?.earnings_saved_as_exchanges}
          currency={currency}
        />
      </Styles.EarningsGroup>
    </Styles.InsightsRow>
  )
}

export default GeneralMetricsCard
